import './pdf.scss';
import '../../Inclusions/entetes/_entete.js';
import '../../Inclusions/pieds/_pied.js';
import '../../Inclusions/menus/_menu.js';
import { initialiserVisionneuse } from './_visionneuse.js';
import { initialiserRecherche } from './_recherche.js';
import { initialiserProprietes } from './_proprietes.js';
import { initialiserPresentation } from './_presentation.js';
import { initialiserImpression } from './_impression.js';
import { initialiserVignettes } from './_vignettes.js';

const section = document.querySelector('.pdf[data-fichier]');
if (section) {
  initialiserVisionneuse(section)
    .then((visionneuse) => {
      initialiserRecherche(section, visionneuse);
      initialiserProprietes(section, visionneuse);
      initialiserPresentation(section, visionneuse);
      initialiserImpression(section, visionneuse);
      initialiserVignettes(section, visionneuse);
    })
    .catch((erreur) => console.error('Visionneuse PDF :', erreur));
}
